import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerMarketoSubmit = props => {
  const datalayerMarketoFormSubmitHandler = event => {
    const validClasses = ["mktoButton"]
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      // Not sure the best way to prevent this line from erroring. Hopefully this works.
      const form_id =
        event?.target?.closest(".mktoForm").getAttribute("id") || null
      const header = document.querySelectorAll(".header")
      const form_name = header.length > 0 ? header[0]?.innerText : null
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "form_submit_attempt",
        form_type: "marketo_form",
        form_name: form_name,
        marketo_form: form_id,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query = document?.querySelectorAll(".mktoButton").length > 0
  }
  useClickListener(datalayerMarketoFormSubmitHandler, query)
}

export default DatalayerMarketoSubmit
